var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import SearchField1 from "./SearchField1";
import SearchResult from "./SearchResult";
import "@frameworks/salesjourney/stylesheets/components/Generic/SearchField1.scss";
var GenericSearch = function (props) {
    var _a, _b, _c;
    var _d = __read(useState(false), 2), showDropdownList = _d[0], setShowDropdownList = _d[1];
    useEffect(function () {
        var _a;
        console.log("inside search text useEffect");
        if (((_a = props === null || props === void 0 ? void 0 : props.searchText) === null || _a === void 0 ? void 0 : _a.length) > 2) {
            setShowDropdownList(true);
            !!props.setShowSearchResults && props.setShowSearchResults(true);
        }
    }, [props === null || props === void 0 ? void 0 : props.searchText]);
    useEffect(function () {
        console.log("inside search props?.showSearchResults");
        setShowDropdownList(props === null || props === void 0 ? void 0 : props.showSearchResults);
    }, [props === null || props === void 0 ? void 0 : props.showSearchResults]);
    console.log("showDropdownList", props === null || props === void 0 ? void 0 : props.showSearchResults, showDropdownList);
    return (React.createElement("div", { className: "col d-flex primary-generic-search-container position-relative ".concat((_a = props === null || props === void 0 ? void 0 : props.parentClass) !== null && _a !== void 0 ? _a : "") },
        React.createElement(SearchField1, { searchText: props === null || props === void 0 ? void 0 : props.searchText, setSearchText: props === null || props === void 0 ? void 0 : props.setSearchText, placeholder: (_b = props === null || props === void 0 ? void 0 : props.placeholder) !== null && _b !== void 0 ? _b : "Search", searchIcon: "", parentClass: "search-input-container ".concat((_c = props === null || props === void 0 ? void 0 : props.inputClassName) !== null && _c !== void 0 ? _c : "") }),
        (props === null || props === void 0 ? void 0 : props.searchText) && showDropdownList && (props === null || props === void 0 ? void 0 : props.searchResultChild) && (React.createElement(SearchResult, { header: "", body: props === null || props === void 0 ? void 0 : props.searchResultChild, footer: "", onBlur: function () {
                setShowDropdownList(false);
                !!props.setShowSearchResults && props.setShowSearchResults(false);
            } }))));
};
export default GenericSearch;
